/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


const bookTest = document.querySelector(".bookTestBtn");
const floatingBookTest = document.querySelector(".floatingBookTestBtn");

const bookTestButton = () => {
  if (!bookTest || !floatingBookTest) return;
  document.body.scrollTop > 50 || document.documentElement.scrollTop > 50 ? bookTest.style.display = "none" : bookTest.style.display = "inline-block";
  document.body.scrollTop > 50 || document.documentElement.scrollTop > 50 ? floatingBookTest.style.display = "block" : floatingBookTest.style.display = "none";
}
if (window.screen.width > 1150) window.onscroll = () => bookTestButton();

const floatingCross = document.querySelector(".floatingCross");
if (floatingCross && floatingBookTest) {
  floatingCross.addEventListener("click", ()=> {
    floatingBookTest.style.transform =  "scale(0)";
    sessionStorage.setItem('closeBookTest', true);
  });
}

const getBookTest = sessionStorage.getItem('closeBookTest');
if (floatingBookTest) {
  getBookTest ? floatingBookTest.style.transform =  "scale(0)" : floatingBookTest.style.transform =  "scale(1)";
}

/* ShopHelten Upsell — Ajax add + refresh mini-cart */
(function () {
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-shophelten-upsell-add]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    if (button.disabled) return;
    button.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }]
      })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (err) {
            throw err;
          });
        }
        return response.json();
      })
      .then(function (data) {
        var addedItem = Array.isArray(data.items) ? data.items[0] : data;
        var card = button.closest('.ShopheltenUpsell__Card');
        if (card) card.style.display = 'none';

        document.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            variant: addedItem,
            quantity: 1
          }
        }));

        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
      })
      .catch(function (error) {
        button.disabled = false;
        var message = (error && (error.description || error.message)) || 'Kunne ikke tilføje produktet';
        window.alert(message);
      });
  });
})();
